import { getSrcs } from '@helpers/image';
import { Device, until } from '@helpers/media';
import * as React from 'react';
import S from './NavigationImage.styles';
const NavigationImage = (props) => {
    const srcs = getSrcs(props, 768, 375, 7, 231 / 347);
    const sizes = `${until(Device.DesktopSmall)} 100vw, 439px`;
    if (!srcs.src) {
        return null;
    }
    return (React.createElement(S.Container, null,
        React.createElement(S.Image, { src: srcs.src, srcSet: srcs.srcSet, alt: props.altText, role: !props.altText ? 'presentation' : undefined, sizes: sizes, loading: "lazy" })));
};
export default NavigationImage;
